import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

import { DriveFolderRef, driveFolderPath } from '../model/driveFolders';

export const artworkDriveApi = createFeatureApi(queryKeys.artworkDrive);

export const artworkDriveKeys = {
  ...artworkDriveApi.keys,
  orderSummary: (orderId: string) => artworkDriveApi.keys.sub('order', orderId, 'summary'),
  folderAccess: (orderId: string, folder: DriveFolderRef) =>
    artworkDriveApi.keys.sub('order', orderId, 'access', driveFolderPath(folder)),
  order: (orderId: string) => artworkDriveApi.keys.sub('order', orderId),
  planSummary: (planId: string) => artworkDriveApi.keys.sub('plan', planId, 'summary'),
  planAccess: (planId: string) => artworkDriveApi.keys.sub('plan', planId, 'access'),
};
